// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigningEvidence
 */
export interface SigningEvidence {
    /**
     * 
     * @type {string}
     * @memberof SigningEvidence
     */
    attestation_version: string;
    /**
     * 
     * @type {string}
     * @memberof SigningEvidence
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof SigningEvidence
     */
    ip_address?: string;
    /**
     * 
     * @type {string}
     * @memberof SigningEvidence
     */
    method: string;
    /**
     * 
     * @type {string}
     * @memberof SigningEvidence
     */
    signed_at: string;
    /**
     * 
     * @type {string}
     * @memberof SigningEvidence
     */
    signer_id: string;
    /**
     * 
     * @type {string}
     * @memberof SigningEvidence
     */
    signer_role: string;
    /**
     * 
     * @type {string}
     * @memberof SigningEvidence
     */
    user_agent?: string;
}

/**
 * Check if a given object implements the SigningEvidence interface.
 */
export function instanceOfSigningEvidence(value: object): value is SigningEvidence {
    if (!('attestation_version' in value) || value['attestation_version'] === undefined) return false;
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('signed_at' in value) || value['signed_at'] === undefined) return false;
    if (!('signer_id' in value) || value['signer_id'] === undefined) return false;
    if (!('signer_role' in value) || value['signer_role'] === undefined) return false;
    return true;
}

export function SigningEvidenceFromJSON(json: any): SigningEvidence {
    return SigningEvidenceFromJSONTyped(json, false);
}

export function SigningEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningEvidence {
    if (json == null) {
        return json;
    }
    return {
        
        'attestation_version': json['attestation_version'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'ip_address': json['ip_address'] == null ? undefined : json['ip_address'],
        'method': json['method'],
        'signed_at': json['signed_at'],
        'signer_id': json['signer_id'],
        'signer_role': json['signer_role'],
        'user_agent': json['user_agent'] == null ? undefined : json['user_agent'],
    };
}

export function SigningEvidenceToJSON(json: any): SigningEvidence {
    return SigningEvidenceToJSONTyped(json, false);
}

export function SigningEvidenceToJSONTyped(value?: SigningEvidence | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attestation_version': value['attestation_version'],
        'comment': value['comment'],
        'ip_address': value['ip_address'],
        'method': value['method'],
        'signed_at': value['signed_at'],
        'signer_id': value['signer_id'],
        'signer_role': value['signer_role'],
        'user_agent': value['user_agent'],
    };
}
